import { render, staticRenderFns } from "./MeasurementCard.vue?vue&type=template&id=b040b3d6&scoped=true"
import script from "./MeasurementCard.vue?vue&type=script&lang=js"
export * from "./MeasurementCard.vue?vue&type=script&lang=js"
import style0 from "./MeasurementCard.vue?vue&type=style&index=0&id=b040b3d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b040b3d6",
  null
  
)

export default component.exports